// Convert country code to full name
export const getCountryFullName = (country) => {
  if (!country) return '';
  const countryMap = {
    'US': 'United States',
    'USA': 'United States',
    'United States': 'United States',
    'CA': 'Canada',
    'Canada': 'Canada',
    'MX': 'Mexico',
    'Mexico': 'Mexico',
    'UK': 'United Kingdom',
    'GB': 'United Kingdom',
    'United Kingdom': 'United Kingdom'
  };
  return countryMap[country] || country;
};

// Helper function to format address from separate fields
export const formatAddressFromFields = (street, city, state, zip, country) => {
  const addressParts = [];
  
  if (street) addressParts.push(street);
  
  const cityStateZip = [];
  if (city) cityStateZip.push(city);
  if (state) cityStateZip.push(state);
  if (zip) cityStateZip.push(zip);
  
  if (cityStateZip.length > 0) {
    addressParts.push(cityStateZip.join(', '));
  }
  
  if (country) addressParts.push(getCountryFullName(country));
  
  return addressParts.join('\n');
};

// Format currency
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount || 0);
};

// Get today's date in YYYY-MM-DD format
export const getTodayString = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Generate BOL Number
export const generateBOLNumber = (companyId, existingCount = 0) => {
  const now = new Date();
  const year = now.getFullYear().toString();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const sequentialNumber = (existingCount || 0) + 1;
  return `BOL-${year}${month}-${String(sequentialNumber).padStart(4, '0')}`;
};